module.exports = __webpack_public_path__ + "static/media/img11.c10ec438.jpg";